"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var addYears = function addYears(date, years) {
  return (0, _dayjs["default"])(date).add(years, 'year').toISOString();
};

var _default = addYears;
exports["default"] = _default;